'use client';

import { AnchorButton } from './AnchorButton.styles';
import { ExpressiveAnchorButtonProps } from '@exploration/shared-components';
import { ADVISOR_URL, useNavigateToAdvisorPage } from '@exploration/ui-utils';
import { useRouter } from 'next/navigation';

type Props = {
  advisorSearchText?: string;
} & Omit<ExpressiveAnchorButtonProps, 'href'>;

export const AdvisorButton = ({ advisorSearchText, ...rest }: Props) => {
  const { push } = useRouter();
  const navigateToAdvisorPage = useNavigateToAdvisorPage();

  return (
    <AnchorButton
      {...rest}
      href={ADVISOR_URL}
      onClick={() =>
        navigateToAdvisorPage({
          url: ADVISOR_URL,
          inputValue: advisorSearchText,
          router: { push },
        })
      }
    />
  );
};
